export default __webpack_public_path__ + "static/media/pj-avatar.de4523b5.svg";